var exports = {
  "kL": "VoiceStateIcons.module__container___eVNUdD",
  "Kk": "VoiceStateIcons.module__icon___eVNUdD",
  "bU": "VoiceStateIcons.module__iconMuted___eVNUdD",
  "DP": "VoiceStateIcons.module__iconGuildAction___eVNUdD",
};

module.exports = exports;
